import GetRedemptionDataResponse from "@/schemas/GetRedemptionDataResponse"
import SimCardInfo from "./SimCardInfo";
import { Flex, Form } from "antd";
import FormInput from "./FormInput";
import ConfirmButton from "./ConfirmButton";
import Title from "./Typography/Title";
import Text from "./Typography/Text";

const styles = {
  form: {
    flex: 1,
    width: "100%",
  },
  toggleContainer: {
    marginBottom: 16,
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  }
}

export function EditForm(props: {
  data: GetRedemptionDataResponse | undefined;
  isJustRedeemed: boolean;
  handleFinish: () => void;
  formData: Record<string, string>;
  handleSetFormData: (key: string, value: string) => void;
  setFile: (f: File | null) => void;
  redemptionCode: string;
}) {
  const { data, isJustRedeemed, handleFinish, handleSetFormData,
          formData, setFile, redemptionCode } = props;

  if (!data) {
    return <></>
  }

  return (
    <>
      <SimCardInfo
        title={data.title ?? "Redeem"}
        imageUrl={data.image != null && data.image !== ""
                  ? data.image
                  : "/images/sim-card-placeholder.jpg"}
        description={data.description}
      />

      {/* Toggle between arrival (form) and status (usage) views */}
      {/* <ToggleWrapper>
          <Segmented
            options={[
              { label: 'Arrival Date', value: 'arrival' },
              { label: 'Status', value: 'status', disabled: !data.isSubmitted }
            ]}
            value={activeView}
            onChange={(value) => setActiveView(value as 'arrival' | 'status')}
            block
            style={{ width: '100%' }}
          />
        </ToggleWrapper> */}

      {/* { redemptionData?.status === "REDEEMED" && (
            <Title level={3}>This SIM has already been redeemed</Title>
        )} */}
      {isJustRedeemed && data && (
        <>
          <Flex vertical gap={2} justify="center">
            <Title level={3}>Thank you for redeeming</Title>
            <Text>You will receive an email with further details</Text>
          </Flex>
        </>
      )}
      {/* Show form or usage view based on toggle state */}
      {!isJustRedeemed && data && (
        <Form onFinish={handleFinish} style={styles.form}>
          <Form.Item>
            <FormInput
              field={{
                label: "Order Number",
                type: "text",
                name: "",
                maxLength: 1024,
                prefilledValue: redemptionCode!!,
                required: true,
              }}
              value={redemptionCode!!}
            />
          </Form.Item>
          {data.fields.map((field) => (
            <Form.Item key={field.name}>
              <FormInput
                field={field}
                setFile={setFile}
                value={formData[field.name]}
                onChange={(s) => handleSetFormData(field.name, s)}
              />
            </Form.Item>
          ))}
          <ConfirmButton htmlType="submit" />
        </Form>
      )}

      {/* Show eSIM usage view when status is selected */}
      {/* TODO: Fix regressions */}
      {/* {!isJustRedeemed && data && activeView === "status" && <EsimUsagePage />} */}
    </>
  );
}